import api from "./api-manager";

const { REACT_APP_RMP_RMP_API_URL, REACT_APP_RMP_APP_ID, REACT_APP_RDYNAMIC_APP_ID, REACT_APP_API_A39 } = process.env;

export default {
  async loginToRdynamic(params) {
    return api.post(
      `/v1/rmp-apps/apps/otp`,
      {
        source_app_id: REACT_APP_RMP_APP_ID,
        destination_app_id: REACT_APP_RDYNAMIC_APP_ID,
      },
      {
        baseURL: REACT_APP_RMP_RMP_API_URL,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  async checkAppAvailable(params) {
    return api.post(
      `/v1/rmp/business/check-app`,
      {
        appId: params.appId,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * get nexus user info
   * @param {*} params
   * @returns
   */
  async getNexusUserInfo(params) {
    return api.post(
      `/v1/rmp/get-nexus-user-info`,
      {},
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
};
